var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3434 30.5879L8.70364 26.0724L3.45882 24.9957L4.0493 19.8898L0.714844 15.9996L4.0493 12.1442L3.45882 7.03827L8.70364 5.96152L11.3434 1.41138L15.9978 3.56488L20.6521 1.41138L23.3266 5.96152L28.5367 7.03827L27.9462 12.1442L31.2807 15.9996L27.9462 19.8898L28.5367 24.9957L23.3266 26.0724L20.6521 30.5879L15.9978 28.4344L11.3434 30.5879ZM12.2812 27.8439L15.9978 26.2808L19.8185 27.8439L22.1457 24.3705L26.2095 23.3285L25.7927 19.1951L28.6062 15.9996L25.7927 12.7346L26.2095 8.60129L22.1457 7.62874L19.749 4.15535L15.9978 5.71838L12.177 4.15535L9.84986 7.62874L5.78599 8.60129L6.2028 12.7346L3.38935 15.9996L6.2028 19.1951L5.78599 23.3979L9.84986 24.3705L12.2812 27.8439Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoCheck);
export default __webpack_public_path__ + "static/media/no-check.b10fc78b85da6eb039656d43e7b5b709.svg";
export { ForwardRef as ReactComponent };